import { ChatRoomAgentFeedbackRating } from '@commenda/types';
import { fetcher, throwApiError } from '@commenda/utils';

export async function submitAgentFeedback(
  chatRoomId: string,
  messageId: string,
  rating: ChatRoomAgentFeedbackRating
): Promise<void> {
  const res = await fetcher(
    `chatRoom/${chatRoomId}/message/${messageId}/agent-feedback`,
    { method: 'POST', body: { rating } }
  );

  if (!res.ok) {
    await throwApiError(
      res,
      'Your feedback could not be saved. Try again in a moment.'
    );
  }
}
